"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo, useState } from "react";
import { TECHS, TECH_CATEGORIES, type Tech } from "@/constants";
export function useTechFilter() {
  const $ = _c(5);
  const [active, setActive] = useState("All");
  let t0;
  bb0: {
    if (active === "All") {
      t0 = TECHS;
      break bb0;
    }
    let t1;
    if ($[0] !== active) {
      t1 = TECHS.filter(t => t.category === active);
      $[0] = active;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    t0 = t1;
  }
  const filtered = t0;
  let t1;
  if ($[2] !== active || $[3] !== filtered) {
    t1 = {
      active,
      setActive,
      filtered
    };
    $[2] = active;
    $[3] = filtered;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}